import ModalController from '../../assets/js/controllers/modal';

// static constants
import WistiaEvent from '../../assets/js/constants/wistia-event';

// helpers
// import { validateParamBoolean } from '../../assets/js/helpers';

export default class ModalWebinar {

	static selector = 'modal-webinar';

	// class variables

	config = {
		wistiaId: null
	};

	el = {};

	// constructor

	constructor(container) {
		this.el = {
			container
		};

		this.config.wistiaId = this.el.container.dataset.wistiaId;

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add / remove event listeners

	#addEventListeners = () => {
		document.body.addEventListener('hsvalidatedsubmit', this.#onFormSubmit);
	}

	#removeEventListeners = () => {
		document.body.addEventListener('hsvalidatedsubmit', this.#onFormSubmit);
	}

	// listener methods

	#onFormSubmit = (e) => {
		for (let i = 0; i < e.path.length; i++) {
			const $pathItem = e.path[i];
			if ($pathItem instanceof Element && this.el.container.contains($pathItem)) {
				document.body.dispatchEvent(new CustomEvent(WistiaEvent.GATE_UNLOCKED, { detail: { wistiaId: this.config.wistiaId } }));
				ModalController.close();
				break;
			}
		}
	}

	// destroy

	destroy() {
		this.#addEventListeners();
	}

}
